import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./Home"; // Updated to include About content
import Prices from "./Prices"; // Create this component
import FAQ from "./FAQ"; // Create this component
import Contact from "./Contact"; // Create this component
import Gallery from "./Gallery"; // Import the new Gallery component
import ErrorBoundary from "./ErrorBoundary"; // Import the error boundary

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="app">
          <header className="header">
            <img src="/image/Logo.png" alt="Iryna Laser Glow Logo" className="logo" />
            <div className="header-content">
              <h1 className="header-title">Iryna Laser Glow</h1>
              <p>Professional laser hair removal by certified specialists.</p>
              <nav className="button-nav">
                <Link to="/">Home</Link>
                <Link to="/prices">Price List</Link>
                <Link to="/gallery">Gallery</Link>
                <Link to="/faq">FAQ</Link>
                <Link to="/contact">Contact Us</Link>
              </nav>
            </div>
          </header>
          <hr />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/prices" element={<Prices />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>

          <footer>
            <p>&copy; 2024 Iryna Laser Glow</p>
          </footer>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
